import 'babel-polyfill';
import PageController from './Controller/PageController';
import Controller from './Controller/Controller';

$('[data-equalizer]').on('postequalized.zf.equalizer', (e) =>  {
  $(e.currentTarget).addClass('equalized');
  // PageController.checkRowsContainsBox();
});

// Initialize Foundation JavaScript
$(document).foundation();

$(document).ready(function () {
  // Initialize Fancybox links
  $('a[class*=fancybox],a[class*=lightbox],a[rel*=fancybox]').fancybox({
      live: false
    }
  );

  // Initialize Controller
  Controller.initialize();
});

$(window).on('load', () => {
	Controller.onLoad();
});
